var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 84.7 74",
    style: {
      enableBackground: "new 0 0 84.7 74"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0LogoRust{fill:#e16c46;}\n\t.st1LogoRust{fill:#e16c46;}\n\t.st2LogoRust{fill:url(#SVGID_1_LogoRust);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0LogoRust",
    d: "M51.8,29.8c1.2-1.2,1.2-3.2,0-4.4l-7-7l0,0c0,0,0,0,0,0c-1.2-1.2-3.2-1.2-4.4,0c-1.2,1.2-1.2,3.2,0,4.4 c0,0,0,0,0,0l7,7C48.6,31,50.6,31,51.8,29.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1LogoRust",
    d: "M44.5,56.6c1.2-1.2,1.2-3.2,0-4.4l-7-7l0,0c0,0,0,0,0,0c-1.2-1.2-3.2-1.2-4.4,0s-1.2,3.2,0,4.4c0,0,0,0,0,0l7,7 C41.3,57.9,43.3,57.9,44.5,56.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_LogoRust",
    gradientUnits: "userSpaceOnUse",
    x1: 4.6977,
    y1: 37.3297,
    x2: 80.0527,
    y2: 37.3297
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1675,
    style: {
      stopColor: "#e16c46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8925,
    style: {
      stopColor: "#e16c46"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2LogoRust",
    d: "M79.5,36.2c-1.3-2.5-4.5-2.8-6.3-1L48.7,59.6c-3.7,3.7-9.7,3.7-13.4,0l-7-7c-3.1-3.1-3.1-8.1,0-11.2l0.3-0.3 c3.2-3.2,7.7-3.3,10.5-0.9l0.6,0.6c5.9,5.9,16.2,4.4,20.8-0.2l1.8-1.8c6.2-6.2,6.2-16.3,0-22.5l-7.8-7.8c-6.7-6.7-17.5-6.7-24.2,0 L6.1,32.9c-1.4,1.4-1.9,3.7-0.9,5.5c1.3,2.5,4.5,2.8,6.3,1L35.8,15c3.7-3.7,9.7-3.7,13.4,0l7,7c3.1,3.1,3.1,8.1,0,11.2l-0.3,0.3 c-3.3,3.3-8.1,3.3-10.9,0.5l-0.1-0.1l0,0l-0.2-0.1C38.9,27.9,28.6,29.3,24,34l-1.8,1.8C16,42,16,52,22.2,58.3l7.8,7.8 c6.7,6.7,17.5,6.7,24.2,0l24.5-24.3C80,40.3,80.5,38.1,79.5,36.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon);
export default __webpack_public_path__ + "static/media/app-icon.0c63a5dda6e9e216450a4735075e6e0d.svg";
export { ForwardRef as ReactComponent };